import TaxiOfficerAddRequest from "../../api/raily/taxi-officer/add/taxi-officer-add.request";
import taxiOfficerApiService from "../../api/raily/taxi-officer/taxi-officer-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import HttpError from "../../utils/http/http.error";
import TaxiOfficerAddError from "./add/taxi-officer-add-error";
import TaxiOfficerAddParams from "./add/taxi-officer-add-params";
import taxiOfficerAddParamsFactory from "./add/taxi-officer-add-params.factory";
import TaxiOfficerEditError from "./edit/taxi-officer-edit-error";
import TaxiOfficerEditParams from "./edit/taxi-officer-edit-params";
import { TaxiOfficerEditRequest } from "../../api/raily/taxi-officer/edit/taxi-officer-edit.request";
import taxiOfficerEditParamsFactory from "./edit/taxi-officer-edit-params.factory";
import TaxiOfficerDetailsParams from "./details/taxi-officer-details-params";
import TaxiOfficerDetails from "./details/taxi-officer-details";
import TaxiOfficerDetailsRequest from "../../api/raily/taxi-officer/details/taxi-officer-details.request";
import taxiOfficerDetailsParamsFactory from "./details/taxi-officer-details-params.factory";
import taxiOfficerDetailsFactory from "./details/taxi-officer-details.factory";
import TaxiOfficerDetailsError from "./details/taxi-officer-details-error";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";

const add = async (
  params: TaxiOfficerAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: TaxiOfficerAddRequest =
    taxiOfficerAddParamsFactory.create(params);

  try {
    const response = await taxiOfficerApiService().add(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | TaxiOfficerAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const edit = async (
  taxiOfficerUuid: string,
  params: TaxiOfficerEditParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: TaxiOfficerEditRequest =
    taxiOfficerEditParamsFactory.create(params);

  try {
    const response = await taxiOfficerApiService().edit(
      taxiOfficerUuid,
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | TaxiOfficerEditError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const getDetails = async (
  params: TaxiOfficerDetailsParams,
  abortSignal: AbortSignal,
): Promise<TaxiOfficerDetails> => {
  const request: TaxiOfficerDetailsRequest =
    taxiOfficerDetailsParamsFactory.create(params);

  try {
    const response = await taxiOfficerApiService().getDetails(
      request,
      abortSignal,
    );

    if (response.status !== 200) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }

    const taxiOfficerDetails = taxiOfficerDetailsFactory.create(response.data);

    return taxiOfficerDetails;
  } catch (_error) {
    const error = _error as HttpError | TaxiOfficerDetailsError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const taxiOfficerService = {
  add,
  edit,
  getDetails,
};

export default taxiOfficerService;
